import request from './request'

export default {
  async list(query: Record<string, any> = {page:1}){
    return await request(process.env.VUE_APP_API_URL + "/services/test-locales", {method:"GET", query: query})
  },
  async get(testDefId: string, locale: string){
    return await request(process.env.VUE_APP_API_URL + "/services/test-locales", {method:"GET", query:{testDefId, locale}})
  }
}